<div class="sidebar-wrapper {{buttonName}}">
  <div class="leftSidebarButton">
    <button (click)="toggle()" id="bt" class="tr-btn">
      
      <i class="fa fa-angle-right"></i>
    </button>
    <!-- <a href="javascript:void(0)" class="btn tr-btn tr-btn ">
      <i class="fa fa-angle-right"></i>
    </a> -->
  </div>
  <div class="sidebar-content">
    <!-- <div class="sidebar-logo niit-logo-icon">
          <a href="javascript:void(0)" title="NIIT"><img src="assets/logo.svg" class="img-responsive"></a>
      </div> -->
    <ul class="sidebar-content-list">
      <li class="" [routerLinkActive]="['active']">
        <a title="BU" [routerLink]="['/ibu']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fa fa-users"></i>
          </span>
          <span class="sd-iconLabel">BU</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Towers" [routerLink]="['/tower']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-layer-group"></i>
          </span>
          <span class="sd-iconLabel">Towers</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
          <a title="Management User" [routerLink]="['/manageUsers']" class="sidebar-content-list-icon">
            <span class="sd-icon">
              <i class="fas fa-user-tie"></i>
            </span>
            <span class="sd-iconLabel">Management User</span>
          </a>
        </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Behavioral Skill Config" [routerLink]="['/behSkillMaster']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fa fa-user-cog"></i>
          </span>
          <span class="sd-iconLabel">Behavioral <br> Skill Config</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Dashboard" [routerLink]="['/funSkillMaster']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fa fa-tasks"></i>
          </span>
          <span class="sd-iconLabel">Functional <br> Skill Config</span>
        </a>
      </li>
    </ul>
  </div>
</div>